import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api/axios';
import TemplatePage from '../components/TemplatePage/TemplatePage';

const UserView = () => {
  const { slug } = useParams();
  const [pageData, setPageData] = useState(null);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const response = await api.get(`/admin/template/${slug}`);
        setPageData(response.data);
      } catch (error) {
        console.error('Error al cargar los datos de la plantilla:', error);
      }
    };

    if (slug) fetchPageData();
  }, [slug]);

  if (!pageData) return <p>Cargando...</p>;

  return (
    <div>
      {/* Pasamos el prop viewMode como true */}
      <TemplatePage slug={slug} viewMode={true} />
    </div>
  );
};

export default UserView;

